var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('IntroInfoSecurity'),_c('CommonBlocksCards',{attrs:{"title":"Типы охраны","blocksInfo":_vm.securityTypes}}),_c('Tariffs',{attrs:{"tariffs":_vm.tariffsList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }